package org.gstechnovos.jexonplastech.util

import androidx.compose.runtime.staticCompositionLocalOf
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint

object Constants {

    const val WEBSITE = "https://jexonplastech.com"
    const val SECTION_WIDTH = 1200
    val LocalBreakpoint = staticCompositionLocalOf { Breakpoint.ZERO }
    const val FONT_FAMILY = "Roboto"

    const val FacebookLink = "https://jexonplastech.com"
    const val TwitterLink = "https://twitter.com"
    const val InstagramLink = "https://instagram.com"
    const val LinkedinLink = "https://linkedin.com"

}

object Res {
    private const val BASE = "/images"

    object Strings {

        const val APP_NAME = "Jexon Plastech"

        object Header {
            const val PHONE = "+91 9876543210"
            const val EMAIL = "support@example.com"
        }

        object Footer

        object Home

        object AboutUs
    }

    object Icon {
        const val web = "web_icon.svg"
        const val seo = "seo_icon.svg"
        const val design = "design_icon.svg"
        const val business = "business_icon.svg"
        const val apple = "apple_icon.svg"
        const val android = "android_icon.svg"

        const val link = "link_icon.svg"

        const val user = "user_icon.svg"
        const val shield = "shield_icon.svg"
        const val happy = "happy_icon.svg"
        const val checkmark = "checkmark_icon.svg"

        const val star = "star_icon.svg"
    }

    object Icons {
        private const val PATH = "$BASE/icons"
        const val CALL = "$PATH/ic_call.svg"
        const val SEND_EMAIL = "$PATH/ic_email.svg"
        const val LOCATION = "$PATH/ic_location.svg"
        const val WEB = "$PATH/ic_web.svg"
        const val EMAIL_CONTACT = "$PATH/ic_email_contact.svg"


        const val FACEBOOK = "${PATH}/ic_facebook.svg"
        const val INSTAGRAM = "${PATH}/ic_instagram.svg"
        const val LINKEDIN = "${PATH}/ic_linkedin.svg"
        const val TWITTER = "${PATH}/ic_twitter.svg"
    }

    object Image {

        const val BRAND_LOGO = "$BASE/logo.svg"

        // Everything related to the Homepage goes inside this object
        object Home {
            private const val PATH = "$BASE/home"

            object Hero {
                private const val SUB_PATH = "$PATH/hero"

                const val HOME_BANNER_1 = "$SUB_PATH/home_banner_1.png"
                const val HOME_BANNER = "$SUB_PATH/home_banner.png"
                const val HOME_BANNER_2 = "$SUB_PATH/home_banner_2.png"
                const val HOME_BANNER_3 = "$SUB_PATH/home_banner_3.png"
            }

            object Products {

                private const val SUB_PATH = "$PATH/products"

                const val BRUSHES = "$SUB_PATH/cleaning_brushes.jpg"
                const val WIPERS = "$SUB_PATH/floor_wipers.jpg"
                const val BROOMS = "$SUB_PATH/brooms.jpg"
                const val BASKETS = "$SUB_PATH/vegetable_baskets.jpg"
            }

            object Manufacturing {
                private const val SUB_PATH = "$PATH/manufacturing"

                const val BPA_FREE = "$SUB_PATH/bpa_free.png"
                const val DURABILITY = "$SUB_PATH/durability.png"
                const val PRODUCTION = "$SUB_PATH/production.png"
            }

            object Overview {
                private const val SUB_PATH = "$PATH/overview"

                const val HOME_OVERVIEW = "$SUB_PATH/home_overview.png"
            }
        }

        object About {

            private const val PATH = "$BASE/about"

            object Executives {
                private const val SUB_PATH = "$PATH/team"

                const val CEO = "$SUB_PATH/js_pic.png"
                const val DIRECTOR = "$SUB_PATH/ps_pic.png"
            }

            object INFRASTRUCTURE {
                private const val SUB_PATH = "$PATH/infrastructure"

                const val MACHINERY = "$SUB_PATH/machinery.svg"
                const val PRODUCTION = "$SUB_PATH/production.svg"
            }

            object Mission {
                private const val SUB_PATH = "$PATH/mission"

                const val PARTNERSHIP = "$SUB_PATH/partnership.svg"
                const val QUALITY = "$SUB_PATH/quality.svg"
                const val SAFETY = "$SUB_PATH/safety.svg"
            }
        }

        object Products {
            private const val PATH = "$BASE/products"

            object CLEANING_BRUSH{
                private const val SUB_PATH = "$PATH/cleaning_brushes"

                const val TYPE_BRUSH_8 = "$SUB_PATH/8_type_brush.png"
                const val GROUND_BRUSH = "$SUB_PATH/ground_brush.png"
                const val OVAL_BRUSH = "$SUB_PATH/oval_brush.png"
                const val PAN_BRUSH = "$SUB_PATH/pan_brush.png"
                const val SQUARE_BRUSH = "$SUB_PATH/square_brush.png"
                const val WOODEN_BRUSH_6 = "$SUB_PATH/wooden_brush_6.png"
                const val WOODEN_BRUSH_7 = "$SUB_PATH/wooden_brush_7.png"
            }

            object TOILET_BRUSHES{

                private const val SUB_PATH = "$PATH/toilet_brushes"

                const val MEDIUM_SINGLE_HOCKEY = "$SUB_PATH/medium_single_hockey.png"
                const val BIG_SINGLE_HOCKEY = "$SUB_PATH/big_single_hockey.png"
                const val SMALL_DOUBLE_HOCKEY = "$SUB_PATH/small_double_hockey.png"
                const val BIG_DOUBLE_HOCKEY = "$SUB_PATH/big_double_hockey.png"
                const val BLACK_HOCKEY = "$SUB_PATH/black_hockey.png"
                const val ROUND_HOCKEY = "$SUB_PATH/round_hockey.png"
                const val BIG_ROUND_HOCKEY = "$SUB_PATH/big_round_hockey.png"
            }

            object FLOOR_WIPERS{
                private const val SUB_PATH = "$PATH/floor_wipers"

                const val WIPER_8 = "$SUB_PATH/8_wiper.png"
                const val WIPER_12 = "$SUB_PATH/12_floor_wiper.png"
                const val WIPER_18 = "$SUB_PATH/18_floor_wiper.png"
            }

            object BROOMS{
                private const val SUB_PATH = "$PATH/brooms"

                const val BIG_BROOM = "$SUB_PATH/big_broom.png"
                const val FOLDING_V_FAN_BRUSH = "$SUB_PATH/folding_v_fan_brush.png"
                const val MEDIUM_BROOM = "$SUB_PATH/medium_broom.png"
                const val ROUND_FAN_BRUSH = "$SUB_PATH/round_fan_brush.png"
                const val SMALL_BROOM = "$SUB_PATH/small_broom.png"
            }

            object DUST_PANS{
                private const val SUB_PATH = "$PATH/dust_pans"

                const val DUST_PAN = "$SUB_PATH/dust_pan.png"
                const val DUST_PAN_WITH_BRUSH = "$SUB_PATH/dust_pan_with_brush.png"
            }

            object BASKETS_AND_ACCESSORIES{
                private const val SUB_PATH = "$PATH/basket_accessories"

                const val CLOTH_CLIP = "$SUB_PATH/cloth_clip.png"
                const val ROUND_VEGETABLE_BASKET = "$SUB_PATH/round_vegetable_basket.png"
                const val SQUARE_VEGETABLE_BASKET = "$SUB_PATH/square_vegetable_basket.png"
            }

            object SPECIALIZED{
                private const val SUB_PATH = "$PATH/specialized"

                const val SOLAR_CLEANING_BRUSH = "$SUB_PATH/solar_cleaning_brush.jpg"
            }

        }

        object Contact {
            private const val PATH = "$BASE/contact"

            const val HEADQUARTERS = "$PATH/headquarters.svg"
            const val PHONE = "$PATH/phone.svg"
            const val EMAIL = "$PATH/email.svg"
        }

        object Common {
            private const val PATH = "${BASE}/common"

            // Make sure this path is correct and your logo is in the right public directory!
            const val BACK_TO_TOP = "$PATH/ic_back_to_top.svg"
        }
    }

    object Breakpoints {
        val SM = Breakpoint.SM  // 640px
        val MD = Breakpoint.MD  // 768px
        val LG = Breakpoint.LG  // 1024px
        val XL = Breakpoint.XL  // 1280px
        val XXL = Breakpoint.XXL  // 1440px
    }
}